import React from 'react'
import SvgSprite from 'src/svg-sprite/dest/sprite.inline.svg'

import styles from './styles.module.scss'

export default () => {
    return <SvgSprite className={styles.sprite} />
}
